export default __webpack_public_path__ + "static/O0049-ef489d5565e225e84829e279e9ba169e.png";